/* Diwali "added to cart" fireworks: a burst of sparks and a few little rockets
   shoot out of the button that was tapped. One temporary fixed canvas that
   ignores the mouse and touch, removed again when the show is over.
   Framework free. Call DiwaliCartBurst.fire(button). */
(function () {
  'use strict';

  var COLORS = ['#f5a300', '#ffd24a', '#e6195f', '#12a8d6', '#ff6a00', '#8a3ffc', '#2fbf71'];
  var canvas = null;
  var ctx = null;
  var raf = 0;
  var last = 0;
  var w = 0;
  var h = 0;
  var rockets = [];
  var particles = [];
  var flashes = [];

  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(list) { return list[Math.floor(Math.random() * list.length)]; }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensureCanvas() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = window.innerWidth;
    h = window.innerHeight;
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
    }
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function addParticle(x, y, vx, vy, color, gravity, decay, size) {
    particles.push({ x: x, y: y, vx: vx, vy: vy, color: color, gravity: gravity, life: 1, decay: decay, size: size });
  }

  function burst(x, y, count, speed, c1, c2) {
    flashes.push({ x: x, y: y, r: 6, life: 1, color: c1 });
    for (var i = 0; i < count; i++) {
      var angle = Math.random() * Math.PI * 2;
      var v = rand(1.2, 5) * speed;
      addParticle(x, y, Math.cos(angle) * v, Math.sin(angle) * v, Math.random() < 0.7 ? c1 : c2, 0.05, rand(0.014, 0.026), rand(1.2, 2.4));
    }
  }

  function fire(el) {
    if (!el || reduced() || document.hidden) return;
    var rect = el.getBoundingClientRect();
    if (!rect.width && !rect.height) return;
    var small = window.innerWidth < 750;
    var scale = small ? 0.8 : 1;
    var x = rect.left + rect.width / 2;
    var y = rect.top + rect.height / 2;

    ensureCanvas();

    /* sparks straight out of the button */
    burst(x, y, Math.round(46 * scale), scale, '#f5a300', '#ffd24a');

    /* little rockets that leave the button and pop above and beside it */
    var n = small ? 3 : 4;
    for (var i = 0; i < n; i++) {
      var spread = (i / (n - 1)) - 0.5;
      var angle = -Math.PI / 2 + spread * 1.5 + rand(-0.12, 0.12);
      var dist = rand(130, 230) * scale;
      var tx = Math.max(24, Math.min(w - 24, x + Math.cos(angle) * dist));
      var ty = Math.max(24, y + Math.sin(angle) * dist);
      rockets.push({
        x0: x, y0: y, tx: tx, ty: ty, x: x, y: y, t: -i * 0.09,
        duration: rand(560, 760), angle: angle, trail: [],
        c1: pick(COLORS), c2: pick(COLORS), scale: scale
      });
    }
    start();
  }

  function busy() { return rockets.length || particles.length || flashes.length; }

  function start() {
    if (raf) return;
    raf = window.requestAnimationFrame(function frame(ts) {
      raf = 0;
      var dt = last ? Math.min(ts - last, 50) : 16.7;
      last = ts;
      update(dt);
      draw();
      if (busy()) {
        raf = window.requestAnimationFrame(frame);
      } else {
        last = 0;
        if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
        canvas = null;
        ctx = null;
      }
    });
  }

  function update(dt) {
    var step = dt / 16.7;
    var i;

    for (i = rockets.length - 1; i >= 0; i--) {
      var r = rockets[i];
      r.t += dt / r.duration;
      if (r.t < 0) continue;
      var te = 1 - Math.pow(1 - Math.min(r.t, 1), 2);
      var px = r.x;
      var py = r.y;
      r.x = r.x0 + (r.tx - r.x0) * te;
      r.y = r.y0 + (r.ty - r.y0) * te;
      if (Math.abs(r.x - px) + Math.abs(r.y - py) > 0.01) r.angle = Math.atan2(r.y - py, r.x - px);
      r.trail.push({ x: r.x, y: r.y });
      if (r.trail.length > 14) r.trail.shift();
      addParticle(r.x, r.y, rand(-0.4, 0.4), rand(0.2, 1), '#ff9a1f', 0.02, 0.07, 1.3);
      if (r.t >= 1) {
        burst(r.tx, r.ty, Math.round(34 * r.scale), 0.85 * r.scale, r.c1, r.c2);
        rockets.splice(i, 1);
      }
    }

    for (i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      var drag = Math.pow(0.965, step);
      p.vx *= drag;
      p.vy = p.vy * drag + p.gravity * step;
      p.x += p.vx * step;
      p.y += p.vy * step;
      p.life -= p.decay * step;
      if (p.life <= 0) particles.splice(i, 1);
    }

    for (i = flashes.length - 1; i >= 0; i--) {
      var f = flashes[i];
      f.r += 4 * step;
      f.life -= 0.09 * step;
      if (f.life <= 0) flashes.splice(i, 1);
    }
  }

  function draw() {
    if (!ctx) return;
    var i;
    ctx.clearRect(0, 0, w, h);

    for (i = 0; i < flashes.length; i++) {
      var f = flashes[i];
      var g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 3);
      g.addColorStop(0, 'rgba(255, 255, 255, 0.9)');
      g.addColorStop(0.35, f.color);
      g.addColorStop(1, 'rgba(255, 255, 255, 0)');
      ctx.globalAlpha = Math.max(0, f.life * 0.5);
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.r * 3, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.lineCap = 'round';
    for (i = 0; i < rockets.length; i++) {
      var tr = rockets[i].trail;
      for (var k = 1; k < tr.length; k++) {
        var a = k / tr.length;
        ctx.globalAlpha = a * 0.85;
        ctx.strokeStyle = 'rgb(255, 150, 30)';
        ctx.lineWidth = 0.8 + a * 2.2;
        ctx.beginPath();
        ctx.moveTo(tr[k - 1].x, tr[k - 1].y);
        ctx.lineTo(tr[k].x, tr[k].y);
        ctx.stroke();
      }
    }

    for (i = 0; i < particles.length; i++) {
      var p = particles[i];
      var alpha = Math.max(0, p.life);
      var rad = p.size * (0.7 + p.life * 0.6);
      ctx.fillStyle = p.color;
      ctx.globalAlpha = alpha * 0.28;
      ctx.beginPath();
      ctx.arc(p.x, p.y, rad * 2.6, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = alpha;
      ctx.beginPath();
      ctx.arc(p.x, p.y, rad * 1.2, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
    for (i = 0; i < rockets.length; i++) {
      var q = rockets[i];
      if (q.t < 0) continue;
      ctx.save();
      ctx.translate(q.x, q.y);
      ctx.rotate(q.angle);
      ctx.scale(q.scale, q.scale);
      ctx.fillStyle = '#ff9f1a';
      ctx.fillRect(-8, -2.4, 13, 4.8);
      ctx.fillStyle = '#ff5a5f';
      ctx.beginPath();
      ctx.moveTo(5, -2.4);
      ctx.lineTo(11, 0);
      ctx.lineTo(5, 2.4);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    }
  }

  window.DiwaliCartBurst = {
    fire: function (el) {
      /* the editor switch lives on the section the button sits in */
      var scope = el && el.closest ? el.closest('[data-cart-burst]') : null;
      if (scope && scope.getAttribute('data-cart-burst') === 'false') return;
      fire(el);
    }
  };
})();
